import SoundManager from "../../../../../../shared/lib/html5-software-library/src/ranj/audio/SoundManager";
import LanguagePack from "../../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import LayoutManager from "../../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import AppModel from "../../../../../../shared/src/ranj/app/core/AppModel";
import MediatorManager from "../../../../../../shared/src/ranj/app/core/MediatorManager";
import AbstractScreenMediator from "../../../../../../shared/src/ranj/app/ui/AbstractScreenMediator";
import SkinKeys from "../../../../../../shared/src/ranj/app/ui/SkinKeys";
import FeedbackPanelView from "../../feedback/FeedbackPanelView";
import BaseInfoPanelMediator from "../../info-panel/BaseInfoPanelMediator";
import StoryInfoPanelMediator from "../../info-panel/StoryInfoPanelMediator";
import GameModel from "../model/GameModel";

export default class AbstractCollaborationScreenMediator extends AbstractScreenMediator {

    /**
     * 
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {LayoutManager} layoutManager 
     * @param {SoundManager} soundManager 
     * @param {*} gameAssets 
     * @param {GameModel} gameModel 
     * @param {MediatorManager} mediatorManager 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel, mediatorManager) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
        this._gameAssets = gameAssets;
        this._gameModel = gameModel;
        this._speedFactor = AppModel.speedFactor;
        this._mediatorManager = mediatorManager;

        if (ranj.DEBUG) {
            window.screen = this;
        }
    }

    destroy() {
        super.destroy();
        if (window.screen == this) {
            window.screen = null;
        }

        if (!!this._castInfoPanel) {
            this._castInfoPanel.removeAllEventListeners();
            this._castInfoPanel.destroy();
        }

        if (!!this._storyInfoPanel) {
            this._storyInfoPanel.removeAllEventListeners();
            this._storyInfoPanel.destroy();
        }

        if (!!this._castInfoButton) {
            this._castInfoButton.button.removeAllEventListeners();
            this._castInfoButton.destroy();
        }

        if (!!this._storyInfoButton) {
            this._storyInfoButton.button.removeAllEventListeners();
            this._storyInfoButton.destroy();
        }
    }

    addInfoPanel() {
        const castInfoSkin = new this._gameAssets.InfoPanelSkin();
        /** @type {BaseInfoPanelMediator} */
        this._castInfoPanel = this._mediatorManager.createMediator(castInfoSkin, SkinKeys.CAST_INFO_SKIN);
        this._castInfoPanel.addEventListener(BaseInfoPanelMediator.CLOSE, this._handleInfoPanelClose.bind(this));
        this._castInfoPanel.addEventListener(BaseInfoPanelMediator.OPEN, this._handleInfoPanelOpen.bind(this));

        const storyInfoSkin = new this._gameAssets.StoryPanelSkin();
        /** @type {StoryInfoPanelMediator} */
        this._storyInfoPanel = this._mediatorManager.createMediator(storyInfoSkin, SkinKeys.STORY_INFO_SKIN);
        this._storyInfoPanel.setStoryInfo("");

        const infoContainer = new createjs.Container();
        this._target.addChild(infoContainer);
        infoContainer.addChild(storyInfoSkin);
        infoContainer.addChild(castInfoSkin);
        this.anchorObject(storyInfoSkin, Anchor.T);
        this.anchorObject(castInfoSkin, Anchor.T);

        // info buttons
        /** @type {InfoPanelButtonMediator} */
        this._castInfoButton = this._mediatorManager.createMediator(this._target.castPanelButton, SkinKeys.INFO_BUTTON_SKIN);
        this._castInfoButton.button.addEventListener('click', this._handleCastInfoButtonClicked.bind(this));
        /** @type {InfoPanelButtonMediator} */
        this._storyInfoButton = this._mediatorManager.createMediator(this._target.storyPanelButton, SkinKeys.INFO_BUTTON_SKIN);
        this._storyInfoButton.button.addEventListener('click', this._handleStoryInfoButtonClicked.bind(this));

        this.anchorObject(this._target.castPanelButton, Anchor.T);
        this.anchorObject(this._target.storyPanelButton, Anchor.T);
        this._storyInfoButton.hide(true);
    }

    showSavegameRestoredFeedback(y = -150) {
        const str = this.getText("savegame.restored");
        this.showFeedback(str, y);
    }

    showFeedback(str, y = -150) {
        const skin = new this._gameAssets.FeedbackPanel();
        skin.y = y;
        this._target.addChild(skin);
        const view = new FeedbackPanelView(skin);
        view.addEventListener(FeedbackPanelView.CLOSE, () => {
            this._target.removeChild(skin);
        });
        view.setText(str, true);
    }

    _handleInfoPanelClose(e) {

    }
    _handleInfoPanelOpen(e) {

    }


    _handleCastInfoButtonClicked(e) {
        this._castInfoPanel.open();
    }

    _handleStoryInfoButtonClicked(e) {
        this._storyInfoPanel.open();
    }



    _createFadeOverlay(isShown = false) {
        const shape = this._target.addChild(new createjs.Shape());
        const w = 2000, h = 4000;
        shape.alpha = isShown ? 1 : 0;
        shape.graphics.f(getComputedStyle(document.body).backgroundColor).r(-w / 2, -h / 2, w, h);
        this._fadeOverlay = shape;
        // NB: add click eater
        this._fadeOverlay.addEventListener("click", () => { });
    }

    _fadeIn(callback) {
        this._fade(1, 0, callback);
    }

    _fadeOut(callback) {
        this._fade(0, 1, callback);
    }

    _fade(from, to, callback) {
        if (!this._fadeOverlay) {
            this._createFadeOverlay();
        }
        this._fadeOverlay.visible = true;
        this._fadeOverlay.alpha = from;
        const tween = createjs.Tween.get(this._fadeOverlay)
            .to({ alpha: to }, 700 / this._speedFactor, createjs.Ease.quadIn)
            .wait(700 / this._speedFactor);
        if (callback != null) {
            tween.call(callback);
        }
    }
}
